import { apiWithoutInterceptors, apiWithoutAuthentication } from '@/services/api';
import ServiceCategoryTypeEnum from '@/constants/common/service_category_type.js';

const UserScenario = {
  login: (email, password) => {
    return apiWithoutInterceptors.post('login/', {
      email: email,
      password: password,
      platformType: ServiceCategoryTypeEnum.Web.value
    });
  },
  loginForLeFILING: (email, password) => {
    return apiWithoutInterceptors.post('login_for_lefiling/', {
      email: email,
      password: password
    });
  },
  refresh: refresh => {
    return apiWithoutAuthentication.post('refresh/', { refresh: refresh });
  }
};

export default UserScenario;



// WEBPACK FOOTER //
// ./src/api/account/user/scenario.js